import log from "loglevel";

log.setLevel(import.meta.env.VITE_LOG_LEVEL || "error");

export { log };